import { usePerson } from '../../contexts/PersonContext'
import { NavRow } from './NavRow'

interface NavItem {
  label: string
  to: string
  badge?: number | string
  badgeLabel?: string
}

/** Role-dependent primary navigation (parent / parent-solo / kid). */
export function SidebarNav() {
  const { role, isSolo, counters } = usePerson()

  const items: NavItem[] =
    role === 'parent'
      ? isSolo
        ? [
            { label: 'Home', to: '/' },
            { label: 'Browse groups', to: '/browse' },
          ]
        : [
            { label: 'Home', to: '/' },
            { label: 'Needs your yes', to: '/approvals', badge: counters.pendingApprovals, badgeLabel: counters.pendingApprovals === 1 ? 'pending request' : 'pending requests' },
            { label: 'Browse groups', to: '/browse' },
          ]
      : [
          { label: 'Play now', to: '/', badge: counters.onlineFriends, badgeLabel: counters.onlineFriends === 1 ? 'friend online' : 'friends online' },
          { label: 'Browse groups', to: '/browse' },
          { label: 'Find friends', to: '/find' },
          { label: 'My friends', to: '/friends' },
        ]

  return (
    <nav aria-label="Main navigation" className="flex flex-col gap-[2px]">
      {items.map((item) => (
        <NavRow key={item.to} {...item} />
      ))}
    </nav>
  )
}
